// ==============================================
// Login Page
// ==============================================

import React, { useState, FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LoginFormData } from '../types';
import logo from '../assets/images/logo.svg';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, error, clearError } = useAuth();
  
  const [formData, setFormData] = useState<LoginFormData>({ email: '', password: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    clearError();
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!formData.email || !formData.password) return;
    try {
      setIsSubmitting(true);
      await login(formData);
      navigate('/dashboard');
    } catch {
      // handled by context
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page">
      <div className="auth-wrapper">
        <div className="auth-card fade-up">
          <div className="auth-logo">
            <img src={logo} alt="TT Platform" style={{ height: '48px' }} />
          </div>
          <h1 className="auth-title">Bine ai revenit</h1>
          <p className="auth-sub">Autentifică-te în contul tău</p>

          {error && <div className="alert alert-danger mb-3">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Adresă de email</label>
              <input
                type="email" id="email" name="email"
                className="form-control" placeholder="tu@exemplu.com"
                value={formData.email} onChange={handleChange}
                required autoComplete="email"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="form-label">Parolă</label>
              <input
                type="password" id="password" name="password"
                className="form-control" placeholder="••••••••"
                value={formData.password} onChange={handleChange}
                required autoComplete="current-password"
              />
            </div>
            <button type="submit" className="btn btn-primary w-100 py-2 mb-3" disabled={isSubmitting}>
              {isSubmitting
                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />Se autentifică…</>
                : 'Autentificare'
              }
            </button>
          </form>

          <div className="text-center" style={{ fontSize: '.875rem', color: 'var(--tt-text-muted)' }}>
            Nu ai cont?{' '}
            <Link to="/register" style={{ color: 'var(--tt-primary)', textDecoration: 'none', fontWeight: 500 }}>
              Creează unul
            </Link>
          </div>

          {/* <div className="auth-divider">Credenţiale de test</div>
          <div style={{ background: 'var(--tt-surface-2)', borderRadius: 8, padding: '.75rem 1rem', fontSize: '.8rem', color: 'var(--tt-text-muted)' }}>
            <strong style={{ color: 'var(--tt-text-2)' }}>Email:</strong> ion.popescu@example.com<br />
            <strong style={{ color: 'var(--tt-text-2)' }}>Parolă:</strong> password123
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
